<section class="h-screen flex items-center justify-center">
  <div class="flex w-full h-full">
    <div class="w-full lg:w-1/2 flex flex-col items-center justify-between bg-white p-6">
      <!-- Logo -->
      <div class="w-full max-w-lg flex justify-start">
        <img [src]="logoUrl" alt="Logo" class="h-20 w-52"/>
      </div>

      <!-- Form Content -->
      <div class="w-full max-w-lg text-left">
        <!-- STEP 1: Enter Email -->
        @if (currentStep === 1) {
          <div>
            <h4 class="text-2xl font-bold text-black mb-2">Forgot Password?</h4>
            <p class="text-md text-gray-600 mb-5">Enter your email to receive an OTP</p>

            <form [formGroup]="emailFormGroup" (ngSubmit)="sendOtpMail()">
              <div class="mb-4">
                <label class="block text-sm text-gray-700 mb-1">Email <span class="text-red-500">*</span></label>
                <input
                  pInputText
                  formControlName="email"
                  (change)="handleEmailChange()"
                  type="text"
                  placeholder="username@mailid.com"
                  class="w-full h-10 text-sm"
                  required
                />
              </div>

              <div class="text-red-500 text-center mb-3">{{ errorMessage }}</div>
              <p-button
                label="Send OTP"
                type="submit"
                class="w-full"
                styleClass="w-full"
                [disabled]="emailLoader"
              ></p-button>
            </form>
          </div>
        } @else if (currentStep === 2) {
          <div>
            <h4 class="text-xl font-bold text-black mb-2">Verify OTP</h4>
            <p class="text-sm text-gray-600 mb-5">OTP sent to {{ emailFormGroup.get('email')?.value }}</p>

            <form [formGroup]="otpFormGroup" (ngSubmit)="verifyOtp()">
              <!-- Replace with your actual OTP input, below is a sample -->
              <div class="mb-4">
                <label class="block text-sm text-gray-700">Enter OTP</label>
                <p-input-otp
                  [length]="8"
                  formControlName="otp"
                  type="text"
                  styleClass="w-[50px] h-[50px]"
                  [integerOnly]="true"
                />
              </div>

              <div class="text-red-500 text-center mb-3">{{ errorMessage }}</div>
              <p-button
                label="Verify OTP"
                type="submit"
                styleClass="w-full"
                class="w-full"
                [disabled]="otpLoader"
              ></p-button>
            </form>
          </div>
        } @else if (currentStep === 3) {
          <div>
            <h4 class="text-xl font-bold text-black mb-2">Reset Password</h4>
            <p class="text-sm text-gray-600 mb-5">Create a new password</p>

            <form [formGroup]="passwordFormGroup" (ngSubmit)="changePassword()">
              <div class="mb-4">
                <label class="block text-sm text-gray-700">Password <span class="text-red-500">*</span></label>
                <p-password
                  formControlName="password"
                  [feedback]="false"
                  [toggleMask]="true"
                  placeholder="********"
                  inputStyleClass="w-full h-10 text-sm"
                  styleClass="w-full"
                ></p-password>
              </div>

              <div class="mb-4">
                <label class="block text-sm text-gray-700">Confirm Password <span class="text-red-500">*</span></label>
                <p-password
                  formControlName="confirmPassword"
                  [feedback]="false"
                  [toggleMask]="true"
                  placeholder="********"
                  inputStyleClass="w-full h-10 text-sm"
                  styleClass="w-full"
                ></p-password>
              </div>

              <div class="text-red-500 text-center mb-3">{{ errorMessage }}</div>

              @if (!passwordLoader) {
                <p-button
                  label="Reset Password"
                  type="submit"
                  class="w-full"
                ></p-button>
              }
            </form>
          </div>
        } @else if (currentStep === 4) {
          <div class="text-center">
            <svg class="mx-auto mb-3" fill="#26C263" width="150px" height="150px" viewBox="0 0 1024 1024">
              <path
                d="M745.472 352.256c-8.192-4.096-20.48-4.096-28.672 0L462.848 614.4 344.064 491.52c-8.192-8.192-20.48-8.192-28.672 0s-8.192 20.48-4.096 28.672L446.464 655.36h4.096s4.096 0 4.096 4.096h16.384s4.096 0 4.096-4.096h4.096l270.335-274.432c0-8.192 0-20.48-4.096-28.672z"/>
            </svg>
            <h4 class="mb-3">Password Changed</h4>
            <p class="mb-3">Your password has been changed successfully.</p>
            <p-button
              label="Back to Login"
              [routerLink]="['/login']"
              class="text-white px-4 py-2 rounded-lg"
            ></p-button>
          </div>
        }
      </div>

      <div>
        <app-footer></app-footer>
      </div>
    </div>

    <!-- Right Side -->
    <div
      class="hidden lg:flex w-1/2 items-center justify-center relative"
      style="background: linear-gradient(49deg, #1177BD -10.76%, #24419B 39.14%, #24419B 53.75%, #24419B 78.54%, #1177BD 110.95%), #FFF;"
    >
      <div class="flex items-center justify-center">
        <img src="assets/loginImages/ClientLoginBackground.png" alt="Background Image" class="max-w-[80%] h-auto"/>
      </div>
    </div>

  </div>
</section>
